<header class="glassmorphism">
  <!-- @Nico : Temporary change before header would be done in mobile first-->
  <section class="mobile">
    <button type="button" (click)="switchSidebarDisplay()">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
        <path
          fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
      </svg>
      <span class="outside-window">Menu</span>
    </button>
  </section>

  <section class="logo">
    <a [routerLink]="['/']">
      <img
        src="assets/logo-title-dark-mode.svg"
        [ngClass]="{ none: (isDarkMode | async) === false }"
        alt="logo devModeler darkMode"
        (click)="closeSidebar()"
        tabindex="0"
        (keydown.enter)="closeSidebar()" />
      <img
        src="assets/logo-title-ligth-mode.svg"
        [ngClass]="{ none: (isDarkMode | async) }"
        alt="logo devModeler lightMode"
        (click)="closeSidebar()"
        tabindex="0"
        (keydown.enter)="closeSidebar()" />
    </a>
  </section>

  <section class="mobile">
    <button type="button" (click)="loginModal.openCard()" [hidden]="isLoggedIn" aria-label="Ouvrir la modale de connexion">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
      </svg>
    </button>
  </section>

  <section class="theme-toggle-desktop">
    <app-theme-toggle></app-theme-toggle>
  </section>


  <section class="auth-buttons">
    @if (isLoggedIn) {
      <button type="button" class="button-component logout-button" (click)="logout()" aria-label="Se déconnecter">
        <svg-logout></svg-logout>
        <span>Se déconnecter</span>
      </button>
    } @else {
      <button type="button" class="login-button" (click)="loginModal.openCard()">Se connecter</button>
      <button type="button" class="button-component" (click)="registerModal.openCard()">S'inscrire</button>
    }
  </section>
</header>

<app-glass-modal #loginModal [hidden]="isLoggedIn">
  <app-user-login
    (loginSuccess)="loginModal.closeCard()"
    (forgotPasswordRequest)="openForgotPasswordModal($event)"
    (openRegister)="openRegisterModal()"></app-user-login>
</app-glass-modal>

<app-glass-modal #registerModal [hidden]="isLoggedIn">
  <app-user-register></app-user-register>
</app-glass-modal>

<app-glass-modal #forgotPasswordModal>
  <app-forgot-password [initialEmail]="emailForReset" (close)="forgotPasswordModal.closeCard()"></app-forgot-password>
</app-glass-modal>
